export const VPLATES_CHANNEL_ID = 1
export const NEW_ORDER_TYPE = "New"
export const RESTYLE_ORDER_TYPE = "Restyle"
export const GIFTVOUCHER_ORDER_TYPE = "GiftVoucher"
export const ORDER_NUMER_FORMAT = "D9"
export const ORDER_NUMER_TYPE = "VPL"